import React from "react"

function IconArrowPrevious({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="arrow-previous"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-arrow-previous"
      {...props}
    >
      <path
        d="m6.654 11.5 7.73-7.248a.873.873 0 0 1 1.47.637v14.495a.873.873 0 0 1-1.47.637l-7.77-7.288a.873.873 0 0 1 .04-1.233zm1.234.636 6.656 6.241V5.895l-6.656 6.241z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconArrowPrevious
